<template>
  <div class="template-container">
    <div class="card-black">
      <div class="card-header">
        <a href="#" @click="goBack" class="icon-link">
          <span class="material-icons">chevron_left</span>
        </a>
        <span>Fusco Fit</span>
        <a href="#/user" class="icon-link">
          <span class="material-icons">home</span>
        </a>
      </div>
      <div class="titolo-card-mobile">
        <h1>LA TUA ASSISTENZA TECNICA</h1>
      </div>
      <div class="create-ticket">
        <p>Inizia la conversazioen descrivendo la problematica, ti risponderemo prima possibile.</p>
        <form @submit.prevent="createTicket">
          <textarea v-model="description" placeholder="Descrizione"></textarea>
          <div v-if="alertMessage" :class="{'alert-success': alertSuccess, 'alert-error': !alertSuccess}">
            {{ alertMessage }}
          </div>
          <div class="button-container">
            <button type="submit" :disabled="isButtonDisabled">Invia</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getFirestore } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {
  createUserTechnicalTicket,
  resolveUserTechnicalTicket,
} from '@/lib/userTechnicalTicket';

export default {
  setup() {
    const title = ref('');
    const description = ref('');
    const alertMessage = ref('');
    const alertSuccess = ref(false);
    const isButtonDisabled = ref(false);
    const router = useRouter();

    const createTicket = async () => {
      isButtonDisabled.value = true; // Disabilita il bottone

      const db = getFirestore();
      const auth = getAuth();
      const userId = auth.currentUser?.uid;
      if (!description.value.trim()) {
        alertMessage.value = 'INSERISCI UNA DESCRIZIONE';
        alertSuccess.value = false;
        isButtonDisabled.value = false;
        return;
      }

      try {
        const { ticketId } = await createUserTechnicalTicket(db, {
          userId,
          title: title.value,
          description: description.value,
        });
        console.log('Ticket tecnico pronto. ID:', ticketId);
        alertMessage.value = 'TICKET CREATO CON SUCCESSO';
        alertSuccess.value = true;
        router.replace({
          name: 'UserTicketConversationTecnico',
          params: { ticketId },
        });
      } catch (error) {
        alertMessage.value = 'IMPOSSIBILE CREARE UN TICKET TECNICO';
        alertSuccess.value = false;
        console.error('Errore nella creazione del ticket:', error);
      } finally {
        isButtonDisabled.value = false;
      }
    };

    onMounted(() => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        unsubscribe();
        if (!user) return;

        try {
          const ticket = await resolveUserTechnicalTicket(getFirestore(), user.uid);
          if (ticket?.id) {
            router.replace({
              name: 'UserTicketConversationTecnico',
              params: { ticketId: ticket.id },
            });
          }
        } catch (error) {
          console.error('Errore recupero ticket tecnico:', error);
        }
      });
    });

    return {
      title,
      description,
      createTicket,
      alertMessage,
      alertSuccess,
      isButtonDisabled
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
};
</script>
